import type { WhatsNewBody } from '../types';
import { buildEntries } from './entries';

/**
 * Every entry under `entries/`, newest first. Read at build time by Vite, so adding an entry is
 * adding a file and nothing else.
 */
export const ENTRIES = buildEntries(
  import.meta.glob<{ default: WhatsNewBody }>('../entries/*.ts', { eager: true }),
);
